// extracted by mini-css-extract-plugin
export default {"back":"Aside_back__A7t0F","back--left":"Aside_back--left__uoSMQ","back--right":"Aside_back--right__DnBl2","aside":"Aside_aside__0vHfP","aside--hidden":"Aside_aside--hidden__97sAZ"};